<template>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3 dense >
      <v-card>
        <v-card-title   class="teal" xs12>
            <div class="col-12">
            <span class="white--text">
                <v-icon small flat class="orange--text">star</v-icon>&nbsp;
                <strong>{{company.name}}</strong>
                &nbsp;
             <v-chip small class="primary" color="white--text">{{company.active ===1 ?'Active' :'Inactive'}}</v-chip>    
            </span>
            </div>
        </v-card-title>
        <v-card-text>
            <v-layout>
            <v-flex xs6>
                <span>{{company.address1}},{{company.address2}}
                {{company.address3}}</span><br>
                <span>{{company.city}},</span>
                <span>{{company.states.name}} - {{company.zip}}</span><br/>
                <span>{{company.countries.name}}</span>
            <br/>
            </v-flex>
            <v-divider></v-divider>
            <v-flex xs6>
                <v-layout>
                    <v-flex xs-3 sm3>
                        Auth Type:
                    </v-flex>
                    <v-flex xs-9 sm9>
                        
                        <span class="indigo--text">{{company.auth_type}}</span><br/>        
                        
                    </v-flex>
                    </v-layout>
                    <v-layout>
                    <v-flex xs-3 sm3>
                        Licensing:
                    </v-flex>
                    <v-flex xs-6 sm9>
                        <span class="indigo--text">{{company.license_key}}</span>
                    </v-flex>
                    </v-layout>
            </v-flex>
            </v-layout>
            <br/>
            <v-divider></v-divider>
            <v-layout>
            <v-flex xs12>
                <v-card dense flat  white black--text     style="min-height:300px">
                    <v-card-text>
                        
                        {{company.description}}
                        
                    </v-card-text>
                </v-card>
            </v-flex>
            </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn flat color="orange" @click="editItem()">Edit</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import CompanyModel from '@/api/service/CompanyService';

  export default {
    data () {
      return {
        search: '',
        company  : {}
      }
    },
    created: function() {
      var  $id = this.$route.query.id
      console.log(this.$route.query)
      CompanyModel.findOne({id:$id})
            .then(response => {
                console.log(response)
                this.setcompanies(response)                
            }).catch(error => {
                console.log(error)
        }); 

    },
    mounted: function(){
        var $id = this.$route.query.id
        CompanyModel.findOne({id:$id})
            .then(response => {
                setcompanyies(response)                
            }).catch(error => {

        }); 
    },
    methods: {
        setcompanies($company){
            this.company = $company[0];
            console.log(this.company)
        },
        editItem () {
            var $url ='/company/edit?id='+this.company.id
            this.$router.push($url)
        }
    }

  }
</script>